<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
   name: "arsipData",
   components: {},
   data() {
      return {
         info: {},
         currentPage: 1,
         totalPages: 0,
         loading: true,
      };
   },
   created() {
      this.findAll();
   },
   mounted() { },
   computed: {
      ...mapGetters({
         countAll: "umatArsip/countAll",
      }),
      ...mapState({
         myData: (state) => state.umatArsip.data,
      }),
      isLoading() {
         return this.$store.state.isLoading;
      },
   },
   methods: {
      ...mapActions({
         download: "umatArsip/download",
      }),
      async findAll() {
         await this.$store.dispatch("umatArsip/getAll");
      },
      refreshData() {
         this.findAll();
      },
      onDownload(item) {
         this.download(item.id)
            .then(response => {
               this.forceFileDownload(response, item)
            })
            .catch(() => console.log('error occured'))
      },
      forceFileDownload(response, item) {
         const url = window.URL.createObjectURL(new Blob([response.data]))
         const link = document.createElement('a')
         link.href = url
         link.setAttribute('download', item.file) //or any other extension
         document.body.appendChild(link)
         link.click()
      },
   },
};
</script>

<template>
   <div>
      <Breadcrumbs title="Arsip" />
      <!-- Container-fluid starts-->
      <div class="container-fluid">
         <div class="card">
            <div class="card-header">
               <div class="row">
                  <div class="col-sm-6 create-project-btn"></div>
                  <div class="col-sm-6 create-project-btn">
                     <div class="text-right">
                        <b-button-group class="btn-group-pill">
                           <b-button variant="primary" size="sm" @click="refreshData()" v-b-tooltip.hover title="Refresh">
                              <div v-show="isLoading" class="
												spinner-border spinner-border-sm
												text-light
											" role="status" aria-hidden="true"></div>
                              <i class="fa fa-refresh" v-show="!isLoading"></i>
                           </b-button>
                        </b-button-group>
                     </div>
                  </div>
               </div>
            </div>
            <div class="card-body">
               <b-skeleton-wrapper :loading="!isLoading">
                  <b-skeleton-table :rows="5" :columns="4" :table-props="{ bordered: true, striped: true }"
                     animation="throb"></b-skeleton-table>
               </b-skeleton-wrapper>

               <template v-if="!isLoading">
                  <v-table class="
								table
								b-table
								table-vcenter table-striped table-bordered table-hover
							" :data="myData" :currentPage.sync="currentPage" :pageSize="20" @totalPagesChanged="totalPages = $event">
                     <thead slot="head" class="thead-light">
                        <v-th sortKey="id" defaultSort="asc" class="text-center">ID</v-th>

                        <th>Nama</th>
                        <th class="text-center">Action</th>
                     </thead>
                     <tbody slot="body" slot-scope="{ displayData }">
                        <tr v-for="item in displayData" :key="item.id">
                           <td class="text-center">{{ item.id }}</td>
                           <td>{{ item.nama }}</td>
                           <td class="text-center">
                              <b-btn-group>
                                 <b-button size="sm" variant="outline-dark" @click="onDownload(item)"
                                    v-b-tooltip.hover title="Download">
                                    <i class="fa fa-download"></i>
                                 </b-button>
                              </b-btn-group>
                           </td>
                        </tr>

                        <tr v-if="!displayData.length">
                           <td colspan="100">
                              <p class="text-center p-2">Tidak ada Data</p>
                           </td>
                        </tr>
                     </tbody>
                  </v-table>
                  <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" :maxPageLinks="3"
                     :boundaryLinks="true" />
               </template>
            </div>
         </div>
      </div>
   </div>
</template>

<style scoped>
nav.smart-pagination {
   margin-top: 20px;
}
</style>